import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ContainedButton } from '@guryou/html-components';
import { getAiExercises, stateIsLoading, useEffectOnSuccess } from '@guryou/redux';
import { useAiContext } from 'aiStudio/context/AiContext';
import ButtonGroup from '../components/ButtonGroup';
import { difficultyOptions, muscleGroupOptions } from '../options';

const ExerciseView = () => {
  const { selectedLevels, setSelectedLevels, selectedMuscleGroups, setSelectedMuscleGroups, setExercises } = useAiContext();

  const dispatch = useDispatch();
  const history = useHistory();

  const aiExercises = useSelector(state => state.exercises.aiExercises);

  useEffectOnSuccess([state => state.exercises.aiExercises], data => {
    setExercises(data);
    history.push('/guryou-ai-studio/preview/excercise');
  });

  const handleClick = () => {
    dispatch(getAiExercises({ levels: selectedLevels, muscleAreas: selectedMuscleGroups }));
  };

  const isLoading = stateIsLoading(aiExercises);

  return (
    <>
      <div
        style={{
          flexGrow: 1,
          overflowY: 'auto',
          backgroundColor: '#212121',
          padding: '16px',
          borderRadius: 8,
          margin: '8px 0',
          minHeight: 0,
        }}
      >
        <ButtonGroup
          title="Difficulty"
          options={difficultyOptions}
          isMultiSelect={true}
          value={selectedLevels}
          onChange={setSelectedLevels}
          maxSelect={5}
        />
        <ButtonGroup
          title="Muscle groups"
          isMultiSelect={true}
          options={muscleGroupOptions}
          value={selectedMuscleGroups}
          onChange={setSelectedMuscleGroups}
          maxSelect={7}
          isMultiAreaEnabled={false}
        />
        <ContainedButton marginTop={6} color="secondary" onClick={handleClick} disabled={isLoading} borderRadius={'999px'}>
          GENERATE
        </ContainedButton>
      </div>
    </>
  );
};

export default ExerciseView;
